(function () {
  const getFrames = () => Array.from(document.querySelectorAll('[data-quantity-discount-frame]'))
    .map(frame => {
      if (!frame.quantityDiscountConfig) {
        frame.quantityDiscountConfig = JSON.parse(frame.dataset.quantityDiscountFrame)
      }
      return frame
    })

  getFrames().forEach(frame => {
    updateFrame(frame)
  })

  document.documentElement.addEventListener('wetheme-cart-update', check)
  document.documentElement.addEventListener('wetheme-toggle-right-drawer', check)
  document.documentElement.addEventListener('femtis-cart-discount', updateTwoPlusOneCartCount)
  document.addEventListener('wetheme-change-quantity', event => check(event, true))
  document.addEventListener('input', onQuantityInput, true)
  document.addEventListener('change', onQuantityInput, true)
  document.addEventListener('click', onQuantityButton)

  let latestQuantityChange = 0

  function check (event, isPdpQuantity = false) {
    const frames = getFrames()
    if (!frames.length) return

    const eventQuantity = Number(event?.detail?.quantity)
    const hasEventQuantity = Number.isFinite(eventQuantity)
    const virtualQuantity = hasEventQuantity && eventQuantity > 1 ? eventQuantity : 0
    const quantityChange = hasEventQuantity ? ++latestQuantityChange : latestQuantityChange

    if (hasEventQuantity) {
      const knownCartQuantity = Number(window.femtisCartDiscount?.count)

      frames.forEach(frame => {
        const config = frame.quantityDiscountConfig
        if (config.mode === 'two_plus_one') {
          if (!isPdpQuantity) return
          updateTwoPlusOneForQuantity(frame, config, eventQuantity)
          return
        }

        const fallbackCartQuantity = Number(config.cartCount)
        const configuredCartQuantity = Number.isFinite(fallbackCartQuantity)
          ? fallbackCartQuantity
          : Number(config.count) || 0
        const cartQuantity = Number.isFinite(knownCartQuantity)
          ? knownCartQuantity
          : configuredCartQuantity
        const nextCount = cartQuantity + virtualQuantity

        if (config.count !== nextCount) {
          config.count = nextCount
          updateFrame(frame)
        }
      })
    }

    if (frames.every(frame => frame.quantityDiscountConfig.mode === 'two_plus_one')) return

    fetch(`${window.Shopify?.routes?.root}cart?view=discount`)
      .then(response => response.json())
      .then(response => {
        if (hasEventQuantity && quantityChange !== latestQuantityChange) return

        const total = response.items.reduce(
          (accumulator, item) => accumulator + (
            item['count_for_discount'] ? item.quantity : 0
          ), 0,
        )

        frames.forEach(frame => {
          const config = frame.quantityDiscountConfig
          if (config.mode === 'two_plus_one') return

          config.cartCount = total
          const nextCount = total + virtualQuantity

          if (config.count !== nextCount) {
            config.count = nextCount
            updateFrame(frame)
          }
        })
      })
  }

  function onQuantityInput (event) {
    if (!isPdpQuantityInput(event.target)) return

    const quantity = Number(event.target.value)
    if (!Number.isFinite(quantity)) return

    check({ detail: { quantity } }, true)
    schedulePdpQuantitySync(event.target.closest('wetheme-product-form'), quantity)
  }

  function onQuantityButton (event) {
    const button = event.target?.closest?.('.js-qty__adjust')
    const form = button?.closest?.('wetheme-product-form')
    if (!button || !form) return

    const input = form.querySelector('.js-qty__num')
    const currentQuantity = Number(input?.value) || 1
    const quantity = button.classList.contains('js-qty__adjust--plus')
      ? currentQuantity + 1
      : Math.max(1, currentQuantity - 1)

    updatePdpPromotion(quantity)
    schedulePdpQuantitySync(form, quantity, currentQuantity)
  }

  function isPdpQuantityInput (target) {
    return Boolean(
      target?.matches?.('.js-qty__num') &&
      target.closest?.('wetheme-product-form, .product-form-vue'),
    )
  }

  function schedulePdpQuantitySync (form, fallbackQuantity, previousQuantity) {
    const sync = () => {
      const input = form?.querySelector('.js-qty__num')
      const quantity = Number(input?.value)
      const inputHasChanged = Number.isFinite(quantity) && quantity !== previousQuantity
      updatePdpPromotion(inputHasChanged ? quantity : fallbackQuantity)
    }

    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(sync)
    } else {
      window.setTimeout(sync, 0)
    }
  }

  function updatePdpPromotion (quantity) {
    getFrames().forEach(frame => {
      const config = frame.quantityDiscountConfig
      if (config.mode === 'two_plus_one') {
        updateTwoPlusOneForQuantity(frame, config, quantity)
      }
    })
  }

  function updateTwoPlusOneCartCount (event) {
    const cartQuantity = Number(event.detail?.itemCount)
    if (!Number.isFinite(cartQuantity)) return

    getFrames().forEach(frame => {
      const config = frame.quantityDiscountConfig
      if (config.mode !== 'two_plus_one') return

      config.cartCount = cartQuantity
      if (Number.isFinite(Number(config.productQuantity))) {
        updateTwoPlusOneForQuantity(frame, config, config.productQuantity)
      } else {
        updateTwoPlusOne(frame, config, cartQuantity)
      }
    })
  }

  function getTwoPlusOneCartQuantity (config) {
    const knownCartQuantity = Number(window.femtisCartDiscount?.count)
    if (Number.isFinite(knownCartQuantity)) return knownCartQuantity

    return Number(config.cartCount) || 0
  }

  function updateTwoPlusOneForQuantity (frame, config, quantity) {
    const productQuantity = Math.max(1, Number(quantity) || 1)
    const cartQuantity = getTwoPlusOneCartQuantity(config)
    const additionalProductQuantity = cartQuantity > 0
      ? Math.max(0, productQuantity - 1)
      : productQuantity

    config.productQuantity = productQuantity
    updateTwoPlusOne(frame, config, cartQuantity + additionalProductQuantity)
  }

  function updateFrame (frame) {
    const config = frame.quantityDiscountConfig
    if (config.mode === 'two_plus_one') {
      const cartQuantity = getTwoPlusOneCartQuantity(config)
      config.cartCount = cartQuantity
      updateTwoPlusOne(frame, config, cartQuantity)
      return
    }

    const discount = frame.querySelector('.product-quantity-discount')

    if (!discount) return

    discount.classList.toggle('hidden', false)

    updateQuantityDiscount(frame, config)
  }

  function updateTwoPlusOne (frame, config, quantity) {
    const promotionQuantity = Math.max(1, Number(quantity) || 1)
    config.count = promotionQuantity

    const discount = frame.querySelector('.product-quantity-discount--two-plus-one')
    if (!discount) return

    const description = discount.querySelector('.product-quantity-discount-description')
    const descriptionLabel = promotionQuantity >= 3
      ? config.label?.description?.completed
      : config.label?.description?.pending

    if (description && descriptionLabel) description.textContent = descriptionLabel

    const graph = discount.querySelector('.product-quantity-discount-graph')
    const badges = graph?.querySelectorAll('[data-pqd-step]') || []
    const bar = graph?.querySelector('.pqd-bar')
    const progress = graph?.querySelector('.pqd-progress')
    const percentage = `${promotionQuantity >= 3 ? 100 : promotionQuantity >= 2 ? 50 : 25}%`
    const currentStep = promotionQuantity >= 3 ? 2 : promotionQuantity >= 2 ? 1 : 0

    graph?.style.setProperty('--percentage', percentage)
    bar?.style.setProperty('--percentage', percentage)
    progress?.style.setProperty('width', percentage)

    badges.forEach((badge, index) => {
      const isLowerLevel = index < currentStep

      badge.hidden = isLowerLevel
      badge.classList.toggle('pqd-badge--hidden', isLowerLevel)
      badge.classList.toggle('completed', false)
      badge.classList.toggle('current', index === currentStep)
    })
  }

  function updateQuantityDiscount (frame, config) {
    let pending
    let key

    if (config.count < 2) {
      key = 'ten_percent'
      pending = 2 - config.count
    } else if (config.count < 3) {
      key = 'fifteen_percent'
      pending = 3 - config.count
    }

    const description = frame.querySelector('.product-quantity-discount-description')

    let label
    if (pending) {
      label = pending > 1
        ? config.label.description[key]?.plural
        : config.label.description[key]?.singular

      label = label?.replace('%pending%', pending)
    } else {
      label = config.label?.description.completed
    }

    if (description) description.innerHTML = label

    const graph = frame.querySelector('.product-quantity-discount-graph')
    const dots = graph?.children || []
    let n = 0

    const count = Math.min(3, config.count)
    for (const dot of dots) {
      n++
      dot.classList.toggle('completed', n < count)
      dot.classList.toggle('current', n === count)
    }

    let percentage
    if (config.count >= 3) {
      percentage = 100
    } else if (config.count >= 2) {
      percentage = 50 + (config.count - 2) * 50
    } else {
      percentage = (config.count / 2) * 50
    }

    graph?.style.setProperty('--percentage', `${percentage}%`)
  }
})()
